// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df19a299","863":"295d7123"}[chunkId] + ".chunk.js";
};